/* ==========================================================================================
   Commercial Equipment Online 2026 · ce-footer.js · the footer's animation (stage 3, 09-10-2026)
   sections/ce-footer.liquid, assets/ce-footer.css, assets/ce-logo.css.
   When the footer scrolls into view (a quarter of it on screen) the CEO logo locks together once (C, E along its
   45-degree cuts, O, then the steel sheen: .is-play on the logo) and a slow 45-degree light drifts across the navy while
   the footer stays on screen (.is-in; it stops when the footer leaves, so it costs nothing unseen). Reduced motion, or
   the footer's "Animate" setting off: nothing moves, everything is shown.
   The AI assistant link (data-ce-chat) is opened by snippets/ce-tracking.liquid, like every other one on the site.
   ========================================================================================== */
(() => {
  'use strict';
  const W = window, D = document;
  const reduce = W.matchMedia('(prefers-reduced-motion: reduce)');

  const bind = (f) => {
    if (f.cefBound) return;
    f.cefBound = 1;
    // phones: the quote app's View Quote tab steps aside while the blue bar is on screen (ce-footer.css)
    const bar = f.querySelector('.cef__bar');
    if (bar && 'IntersectionObserver' in W) {
      new IntersectionObserver((es) => es.forEach((e) => D.body.classList.toggle('cef-bar-in', e.isIntersecting))).observe(bar);
    }
    // Tommy 11-10 (on his phone: "i don't love the footer" ... "try it"): on phones the Shop / Support / Information
    // lists fold into tap-to-open rows (.cef--fold, ce-footer.css). Without this script they simply stay open; on a
    // computer the title is the plain heading it always was.
    const fold = W.matchMedia('(max-width: 749px)');
    const cols = Array.prototype.slice.call(f.querySelectorAll('.cef__main > .cef__col'));
    cols.forEach((col, i) => {
      const h = col.querySelector('.cef__col-title'), ul = col.querySelector('.cef__links');
      if (!h || !ul || h.querySelector('.cef__col-btn')) return;
      if (!ul.id) ul.id = 'CefLinks-' + i;
      const b = D.createElement('button');
      b.type = 'button';
      b.className = 'cef__col-btn';
      b.setAttribute('aria-controls', ul.id);
      const t = D.createElement('span');
      t.textContent = h.textContent.trim();
      b.appendChild(t);
      b.insertAdjacentHTML('beforeend', '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M6.5 9.5 12 15l5.5-5.5"/></svg>');
      h.textContent = '';
      h.appendChild(b);
      b.addEventListener('click', () => {
        if (!fold.matches) return;
        const open = !col.classList.contains('is-open');
        col.classList.toggle('is-open', open);
        b.setAttribute('aria-expanded', String(open));
      });
    });
    const syncFold = () => {
      f.classList.toggle('cef--fold', fold.matches);
      cols.forEach((c) => {
        const b = c.querySelector('.cef__col-btn');
        if (!b) return;
        if (fold.matches) { b.setAttribute('aria-expanded', String(c.classList.contains('is-open'))); b.tabIndex = 0; }
        else { b.removeAttribute('aria-expanded'); b.tabIndex = -1; }
      });
    };
    syncFold();
    if (fold.addEventListener) fold.addEventListener('change', syncFold);

    const svg = f.querySelector('.cef__logo .ce-logo--intro');
    // Tommy 10-10 ("the ceo logo in footer should be the same as the one in the header on hover"): once it has locked
    // together, hovering (mouse) or tabbing to it replays the header's short version - C, E and O slide apart, lock, sheen
    // (.is-replay, ce-logo.css)
    const logoA = f.querySelector('a.cef__logo');
    if (svg && logoA) {
      let busyR = false;
      const replay = () => {
        if (busyR || reduce.matches || !svg.classList.contains('is-done')) return;
        busyR = true;
        svg.classList.remove('is-replay'); void svg.getBoundingClientRect(); svg.classList.add('is-replay');
        setTimeout(() => { svg.classList.remove('is-replay'); busyR = false; }, 1300);
      };
      logoA.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') replay(); });
      logoA.addEventListener('focus', replay);
    }
    const animate = f.classList.contains('cef--anim') && !reduce.matches && 'IntersectionObserver' in W;
    if (!animate) { if (svg) svg.classList.add('is-done'); return; }
    f.classList.add('is-armed');
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        f.classList.toggle('is-in', e.isIntersecting);
        if (e.isIntersecting && !f.classList.contains('is-played')) {
          f.classList.add('is-played');
          if (svg) {
            svg.classList.add('is-play');
            setTimeout(() => svg.classList.add('is-done'), 2100);
          }
        }
      });
    }, { threshold: [0, .25], rootMargin: '0px 0px -10% 0px' });
    io.observe(f);
  };

  const init = (root) => (root || D).querySelectorAll('[data-cef]').forEach(bind);
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', () => init()); else init();
  D.addEventListener('shopify:section:load', (e) => init(e.target));
})();
